import React from 'react';
import { Card, CardContent, Typography, Box, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ScrollableMenu = ({ menuItems, cardStyle, avatarStyle, labelStyle }) => {
    const navigate = useNavigate();

    const handleClick = (route) => {
        navigate(route);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                overflowX: 'auto', // Enable horizontal scrolling
                padding: 2,
                width: '100%',
                whiteSpace: 'nowrap', // Prevent items from wrapping to the next line
                '&::-webkit-scrollbar': {
                    height: 8, // Add custom scrollbar height
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888', // Style for the scrollbar thumb
                    borderRadius: 4,
                },
                '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#555', // Darker on hover
                },
            }}
        >
            {menuItems.map((item, index) => (
                <Card
                    key={index}
                    sx={{
                        minWidth: '120px',
                        backgroundColor: 'transparent',
                        marginRight: 2,
                        padding: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                        borderRadius: 2,
                        overflow: 'visible', // Allow overflow to show the floating avatar
                        '&:hover': {
                            boxShadow: 6,
                        },
                        ...cardStyle, // Apply custom card styles
                    }}
                    onClick={() => handleClick(item.route)}
                >
                    <CardContent
                        sx={{
                            position: 'relative', // Set position relative for containing the floating avatar
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            bgcolor: 'transparent',
                            overflow: 'visible', // Ensure content doesn't cut off floating avatar
                        }}
                    >
                        <Avatar
                            src={item.image}
                            onError={(e) => {
                                console.error('Image failed to load:', item.image);
                                e.target.src = '/images/default-avatar.png'; // Fallback image
                            }} sx={{
                                width: 30,
                                height: 30,
                                position: 'absolute', // Make avatar float above the card content
                                top: '-24px', // Position it slightly above the card
                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Add a shadow for a floating effect
                                backgroundColor: 'transparent', // Make background transparent
                                border: 'none', // Remove the border or set it transparent
                                ...avatarStyle, // Apply custom avatar styles
                            }}
                        />
                        <Typography sx={{ fontSize: 12, mt: 2, ...labelStyle }}>{item.label}</Typography>
                    </CardContent>
                </Card>
            ))}
        </Box>
    );
};

export default ScrollableMenu;